import {GameGrid} from "js/Elements/GameGrid";
import {Vec2} from "js/Elements/types";
import {SimulationBubble} from "js/Elements/SimulationBubble";

export type FlyingBubble = {
  onCollision: Phaser.Signal;
  onWallBounce: Phaser.Signal;

  bubbleType: number;
  collCircle: Phaser.Circle;
  x: number;
  y: number;
  vel: Vec2;
  cell: Vec2;
  prevCell: Vec2;
}

export type SimulationResults = {
  positions: Vec2[];
  collision: Vec2 | null;
}

export class BubbleFlyingBehaviour {
  private grid: GameGrid;

  private minX: number;
  private maxX: number;

  private simulationBubble: SimulationBubble = new SimulationBubble();

  constructor(grid: GameGrid) {
    this.grid = grid;

    const horizontalMargin = 40;
    this.minX = this.grid.gridFiledRect.x + horizontalMargin;
    this.maxX = this.grid.gridFiledRect.x + this.grid.gridFiledRect.width - horizontalMargin;
  }

  public update(bubble: FlyingBubble) {
    for (let i = 0; i < 2; i++) {
      this.updatePosition(bubble);
      if (this.checkCollision(bubble)) {
        bubble.onCollision.dispatch();
        break;
      }
    }
  }

  public simulate(bubble: FlyingBubble, maxSteps: number): SimulationResults {
    this.simulationBubble.copyFrom(bubble);

    const result: SimulationResults = { positions: [], collision: null};

    for (let i = 0; i < maxSteps; i++) {
      this.updatePosition(this.simulationBubble);
      result.positions.push({ x: this.simulationBubble.x, y: this.simulationBubble.y });
      if (this.checkCollision(this.simulationBubble)) {
        result.collision = {
          ...this.simulationBubble.cell
        };
        return result;
      }
    }

    return result;
  }

  private checkWallBounce(bubble: FlyingBubble) {
    if (bubble.x < this.minX || bubble.x > this.maxX) {
      const offset = bubble.x < this.minX ? this.minX - bubble.x : this.maxX - bubble.x;
      bubble.x = Phaser.Math.clamp(bubble.x, this.minX, this.maxX) + offset;
      bubble.vel.x *= -1;
      bubble.onWallBounce.dispatch();
    }
  }

  private updatePosition(bubble: FlyingBubble) {
    bubble.x += bubble.vel.x;
    bubble.y += bubble.vel.y;

    this.checkWallBounce(bubble);

    const cellPos = this.grid.outsidePxToCell(bubble.x, bubble.y);

    if (bubble.cell.x != cellPos[0] || bubble.cell.y != cellPos[1]) {
      bubble.prevCell.x = bubble.cell.x;
      bubble.prevCell.y = bubble.cell.y;
      bubble.cell.x = cellPos[0];
      bubble.cell.y = cellPos[1];
    }
  }

  private checkCollision(bubble: FlyingBubble): boolean {
    const coll = this.grid.checkCollisionAgainst(bubble, this.grid.getNeighbours(bubble.cell.x, bubble.cell.y));
    if (coll.length > 0) {
      if (this.grid.getBubble(bubble.cell.x, bubble.cell.y)) {
        bubble.cell.x = bubble.prevCell.x;
        bubble.cell.y = bubble.prevCell.y;
      }

      return true;
    }

    return false;
  }
}
